import React from "react";
import { 
  XTwitterIcon,
  InstagramIcon,
  LinkedInIcon,
  FacebookIcon,
  DiscordIcon 
} from "@/icons/social";

// Social media icon mappings
export const socialIconMappings = {
  FaXTwitter: XTwitterIcon,
  FaInstagram: InstagramIcon,
  FaLinkedinIn: LinkedInIcon, 
  FaFacebook: FacebookIcon,
  FaDiscord: DiscordIcon
};

// Get social media icon component by name
export const getSocialIcon = (iconName: string) => (socialIconMappings as Record<string, React.ComponentType>)[iconName];